/**
 * Navigation Utilities
 * Helper functions for navigation and redirect logic
 */

import { UserPreferences } from '../types/auth.types';
import { isMarketingPath } from '../marketing/utils/marketingPaths';

const EXCLUDED_LAST_PAGES = [
  '/',
  '/login',
  '/register',
  '/register/verify',
  '/stores',
  '/stores/create',
  '/stores/join',
  '/stores/create-from-template',
];

function isUsableLastPage(path: string | null): path is string {
  if (!path) return false;
  if (EXCLUDED_LAST_PAGES.includes(path)) return false;
  if (isMarketingPath(path)) return false;
  return true;
}

/**
 * Get the default redirect path based on user preferences
 * @param preferences - User preferences object
 * @returns The path to redirect to
 */
export const getDefaultRedirectPath = (preferences?: UserPreferences | null): string => {
  if (!preferences || !preferences.default_redirect_page) {
    return '/dashboard';
  }

  const redirectPage = preferences.default_redirect_page;

  switch (redirectPage) {
    case 'dashboard':
      return '/dashboard';
    
    case 'orders':
      return '/orders';
    
    case 'last_visited': {
      const lastVisited = localStorage.getItem('lastVisitedPage');
      return isUsableLastPage(lastVisited) ? lastVisited : '/dashboard';
    }
    
    default:
      return '/dashboard';
  }
};

/**
 * Save the current page as the last visited page
 * Should be called when navigating to a protected route
 * @param pathname - Current pathname
 */
export const saveLastVisitedPage = (pathname: string): void => {
  if (isUsableLastPage(pathname)) {
    localStorage.setItem('lastVisitedPage', pathname);
  }
};

